import tripsEn from './en/en.json'
import tripsAr from './ar/ar.json'
import tripsEs from './es/es.json'
import tripsDe from './de/de.json'
import tripsIt from './it/it.json'
import tripsFr from './fr/fr.json'
import tripsPt from './pt/pt.json'
import tripsEl from './el/el.json'
import tripsBn from './bn/bn.json'
import tripsSr from './sr/sr.json'
import tripsCs from './cs/cs.json'
import tripsPl from './pl/pl.json'
import tripsHu from './hu/hu.json'
import tripsSk from './sk/sk.json'
import tripsRo from './ro/ro.json'
import tripsBg from './bg/bg.json'
import tripsMk from './mk/mk.json'
import tripsSq from './sq/sq.json'

const TripsMessages = {
  en: { trips: { ...tripsEn } },
  ar: { trips: { ...tripsAr } },
  es: { trips: { ...tripsEs } },
  de: { trips: { ...tripsDe } },
  it: { trips: { ...tripsIt } },
  fr: { trips: { ...tripsFr } },
  pt: { trips: { ...tripsPt } },
  el: { trips: { ...tripsEl } },
  bn: { trips: { ...tripsBn } },
  sr: { trips: { ...tripsSr } },
  cs: { trips: { ...tripsCs } },
  pl: { trips: { ...tripsPl } },
  hu: { trips: { ...tripsHu } },
  sk: { trips: { ...tripsSk } },
  ro: { trips: { ...tripsRo } },
  bg: { trips: { ...tripsBg } },
  mk: { trips: { ...tripsMk } },
  sq: { trips: { ...tripsSq } },
}

export default TripsMessages
